import React from "react";
import PropTypes from 'prop-types';

import { Pressable } from "~/native-ui/Pressable";
import { Dialog, dialogPropTypes } from "./Dialog";


export const WithDialog = (Component, extraProps ) => {
    return class WithDialog extends React.PureComponent {
        static propTypes = {
            ...Dialog.propTypes,
            defaultOpen: PropTypes.bool,
        }

        static defaultProps = {
            defaultOpen: false,
            ...extraProps,
        }

        isControlled = this.props.active !== undefined

        state = {
            show: this.props.defaultOpen,
        }

        dialogRef = React.createRef(null);

        componentDidMount() {
            this.dialogRef.current = this;
        }

        
        onOverlayClick = () => {
            this.setState({show: !this.state.show})
        }
        

        toggleDialog = () => {
            this.setState({
                show: !this.state.show
            })
        }

        getProps (filter) {
            const { defaultOpen, dialogProps, ...props } = this.props;
            return Object
                .entries(props)
                .reduce((acc, [key, value]) => filter(key) ? Object.assign(acc, { [ key ]: value }) : acc, {})
        }

        render() {
            const { children, forwardRef, ...dialogProps } = this.getProps((key) => (key in dialogPropTypes))
            const { ...componentProps } = this.getProps((key) => !(key in dialogPropTypes));

            return (
                <React.Fragment>
                    {React.Children.map(children, (child) => React.cloneElement(child, { onPress: this.toggleDialog }))}
                    <Dialog active={ this.state.show } onOverlayClick={this.onOverlayClick} { ...dialogProps} { ...this.props.dialogProps }>
                        <Component dialogRef={ this.dialogRef } { ...componentProps } />
                    </Dialog>
                </React.Fragment>
            )
        }
    }
}